import { IEvent, Topics } from '@zaplify/common';

/**
 * Dispatched when a LinkedIn profile is found to have complete data
 */
export class LinkedinProfileCompleteDataFoundEvent extends IEvent {
    public static override readonly TOPIC: Topics = Topics.PROSPECTS;
    constructor(readonly memberId: string) {
        super();
    }

    get partitionKey(): string {
        return this.memberId;
    }
}
